export function decodeJWT(token: string) {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())
}

export function decodeReservationId(token: string) {
  const { reservationId } = decodeJWT(token)
  return reservationId
}
